import React from "react";
import {
    DataGrid,
    HeaderFilter,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarLoteamentoDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class LoteamentosBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="LOTEAMENTOS">
                    <DataGrid
                        dataSource={criarLoteamentoDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={"id"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'descricao'} caption={"Nome"} wordWrapEnabled={true} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}